// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-form-label {
  margin-bottom: 4px;
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: rgb(115, 115, 115);
}

.input-form-div {
  position: relative;
  width: 100%;
  height: 37px;
  margin-top: 3px;
}

input::placeholder {
  color: rgb(170, 170, 170);
}

.input-form-field {
  font-size: 14px;
  width: 100%;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.invoice-flow .input-form-field:disabled {
  color: #666;
  background-color: #f5f5f5;
}

.misc-flow .input-form-field:disabled {
  color: #666;
  background-color: #f5f5f5;
}

.input-form-field:hover {
  border-color: rgb(8, 145, 178) !important;
}

.input-form-field:focus {
  border: 2px solid rgb(8, 145, 178) !important;
  background-color: rgb(8, 145, 178, 0.1);
  box-shadow: none;
}

.invalid-input-form-field,
.invalid-input-form-field:hover,
.invalid-input-form-field:focus {
  box-shadow: 0 0 0 1px rgb(220, 38, 38);
  border-color: rgb(220, 38, 38) !important;
}

.input-form-field:focus {
  border: 1px solid #28a745;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/input/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;;;EAGE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf","sourcesContent":[".input-form-label {\n  margin-bottom: 4px;\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: rgb(115, 115, 115);\n}\n\n.input-form-div {\n  position: relative;\n  width: 100%;\n  height: 37px;\n  margin-top: 3px;\n}\n\ninput::placeholder {\n  color: rgb(170, 170, 170);\n}\n\n.input-form-field {\n  font-size: 14px;\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.invoice-flow .input-form-field:disabled {\n  color: #666;\n  background-color: #f5f5f5;\n}\n\n.misc-flow .input-form-field:disabled {\n  color: #666;\n  background-color: #f5f5f5;\n}\n\n.input-form-field:hover {\n  border-color: rgb(8, 145, 178) !important;\n}\n\n.input-form-field:focus {\n  border: 2px solid rgb(8, 145, 178) !important;\n  background-color: rgb(8, 145, 178, 0.1);\n  box-shadow: none;\n}\n\n.invalid-input-form-field,\n.invalid-input-form-field:hover,\n.invalid-input-form-field:focus {\n  box-shadow: 0 0 0 1px rgb(220, 38, 38);\n  border-color: rgb(220, 38, 38) !important;\n}\n\n.input-form-field:focus {\n  border: 1px solid #28a745;\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
